<template>
  <div class="ViewEmailUserList">
    <div class="container-fluid padding-left-3Perc padding-right-2Point5Perc">
      <div class="row padding-Top-1Perc padding-bottom-2Perc">
        <div class="col-md-12 col-lg-12 font-size-12px font-color-dark-red text-align-left"></div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped ">
          <thead>
            <tr>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Sender</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Subject</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Template</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Schedule TS</th>
              <th class="text-align-center text-valign-middle font-size-15px">Action</th>            
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc">Sender</td>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc">Subject</td>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc padding-left-0Perc paddding-right-0px">template</td>
              <td class="text-align-center border-right padding-Top-1Perc padding-bottom-1Perc padding-left-0Perc paddding-right-0px">Schedule Ts</td>
              <td class="text-align-center padding-Top-1Perc padding-bottom-1Perc">
                <a class="cursor-pointer"> Users </a>
                <a class="cursor-pointer">| Cancel All </a>
              </td>
            </tr>
          </tbody>
       </table>
    </div>
  </div>
  <!-- <view-users v-if="showUserListOverlay" :userList="notifUserList" :currNotifObj="selectedNotificationObj" :selectedNotifStatus="selectedNotifStatus" @viewOverlay="closeViewUser"></view-users>
  <Update-Schedule-Notification v-if="editUserListOverlay" :currNotifObj="selectedNotificationObj" @viewOverlay="closeEditUser"></Update-Schedule-Notification>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performAction"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> -->
  <!-- Show Spinner 
   <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div> -->
  <loader></loader>
  </div>
</template>
<script>
// import { dmAdminUtils } from '@/utils/dmAdminUtils'
// import { notificationService } from '@/server-util/notification-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import ViewUsers from '@/components/notification/m365/ViewUsersOverlay'
import UpdateScheduleNotification from '@/components/notification/m365/UpdateScheduleNotification'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['notifList', 'selectedNotifStatus'],
  created: function () {},
  data: function () {
    return {}
  },
  methods: {},
  computed: {},
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader,
    'view-users': ViewUsers,
    'Update-Schedule-Notification': UpdateScheduleNotification
  },
  name: 'ViewEmailUserList'
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.ViewMentora365NotifyList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
.tdMargin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-left-1Point7Perc
{
	margin-left: 1.7%;
}
 .margin-right-0Point1Perc
{
	margin-right: 0.1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.text-align-center {
 text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.imgWidthHeight{
  width:180px; 
  height:110px;
}
.padding-Top-1Perc{
  padding-Top:1%;
}
.padding-top-2Perc {
  padding-top: 2% !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color{
  color:#2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.img-background-color {
  background-color: #d4d4d4 !important;
}
.paddding-right-0px{
  padding-right:0%;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.padding-left-3Perc {
  padding-left: 3%;
}
.padding-right-2Point5Perc {
  padding-right: 2.5%;
}
.font-size-12px {
    font-size: 12px !important;
}
.font-color-dark-red {
    color: darkred;
}
.padding-bottom-1Perc {
  padding-bottom:1%;
}
.padding-bottom-2Perc {
  padding-bottom:2%;
}
.text-align-left {
  text-align:left;
}
.padding-left-0Perc {
  padding-left:0%;
}
</style>



// WEBPACK FOOTER //
// src/components/emails/progression_emails/ViewProgressionEmailUserList.vue